import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";

import SignUpFormLayout from "~/common/components/signUp/SignUpFormLayout";
import SignUpProgress from "~/common/components/signUp/SignUpProgress";
import Input from "~/common/components/ui/Input";
import { TeamMemberNamesAndEmailSchemaType } from "~/common/utils/signUpSchemas";

interface TeamMemberNameAndEmailFormProps {
  totalSteps: number;
  register: (
    data: keyof TeamMemberNamesAndEmailSchemaType,
  ) => UseFormRegisterReturn<string>;
  onNext: () => Promise<void>;
  step: number;
  errors?: FieldErrors<TeamMemberNamesAndEmailSchemaType>;
}

export const TeamMemberNameAndEmailForm = ({
  onNext,
  register,
  totalSteps,
  errors,
  step,
}: TeamMemberNameAndEmailFormProps) => (
  <>
    <SignUpProgress step={step} totalSteps={totalSteps} />
    <SignUpFormLayout
      title="Welcome to PsychNow"
      handleData={onNext}
      submitLabel="Continue"
    >
      <div className="flex size-full flex-grow flex-col justify-between lg:justify-normal lg:gap-12">
        <div className="flex w-full flex-col items-center gap-4 md:gap-2">
          <Input
            id="name"
            label="First name"
            {...register("name")}
            error={errors?.name?.message}
          />
          <Input
            id="last_name"
            label="Last name"
            {...register("last_name")}
            error={errors?.last_name?.message}
          />
          <Input
            id="email"
            label="Email address"
            {...register("email")}
            error={errors?.email?.message}
            disabled
          />
        </div>
      </div>
    </SignUpFormLayout>
  </>
);
